// src/components/Inventory/charts/chartPalette.js
export const chartPalette = [
  "#7CFFB2",
  "#58D9F9",
  "#FDDD60",
  "#FF6E76",
  "#A0A7E6",
  "#E2A8FF",
  "#FF9F7F",
  "#9FE6B8",
  "#32C5FF",
  "#B5EAD7",
];
